<script lang="ts">
	import PrimaryButton from '$lib/buttons/primaryButton.svelte';
	import { headerVisible } from '$lib/stores/header';
	import { onMount } from 'svelte';
	import ContainerMargin from './containerMargin.svelte';
	import type { SubNavLinks } from './types';
	import { fade } from 'svelte/transition';
	import { event } from '$lib/utils/tracking';
	import { reservationUrl } from '$lib/stores/utmParams';
	import SubNavLink from '$lib/buttons/subNavLink.svelte';

	interface Props {
		entries: SubNavLinks['entries'];
	}

	let { entries }: Props = $props();

	let mounted = $state(false);

	onMount(() => {
		const mountTimeout = setTimeout(() => {
			mounted = true;
		}, 1000);

		return () => clearTimeout(mountTimeout);
	});
</script>

<div
	class={[
		'bg-stone-5 transition-transform ease-out',
		{
			'duration-300': !$headerVisible,
			'duration-700': $headerVisible,
			'-translate-y-full': !mounted
		}
	]}
>
	<ContainerMargin>
		<nav class="flex items-center justify-between">
			<div class="flex gap-x-6 pt-2 lg:pt-1">
				{#each entries as entry}
					<SubNavLink href={entry.url}>{entry.name}</SubNavLink>
				{/each}
			</div>

			{#if !$headerVisible}
				<div transition:fade>
					<div class="flex items-center lg:hidden">
						<PrimaryButton
							data-testid="btn-subnav-reserve"
							href={$reservationUrl.url}
							size="small"
							onclick={() => event('Sub Navigation Reserve Button Clicked')}
							>{$reservationUrl.label}</PrimaryButton
						>
					</div>

					<div class="flex items-center max-lg:hidden">
						<PrimaryButton
							data-testid="btn-subnav-reserve"
							href={$reservationUrl.url}
							size="medium"
							onclick={() => event('Sub Navigation Reserve Button Clicked')}
							>{$reservationUrl.label}</PrimaryButton
						>
					</div>
				</div>
			{/if}
		</nav>
	</ContainerMargin>
</div>
